import { keys, identity } from 'ramda';

/** Checks if the argument is a valid string having the minimum Length of second argument */
export const validString = (minLength = 1) => (str) => {
  return str && typeof str === 'string' && str.length >= minLength;
};

/** Validates if all the values of the object is validated by the validator Function */
export const allValid = (validatorFunc = validString(1)) => (validationObject = {}) => {
  const validations = keys(validationObject).map((key) => [key, validatorFunc(validationObject[key])]);
  if (validations.map(([key, v]) => v).every(identity)) {
    return {
      valid: true
    };
  } else {
    return {
      valid: false,
      invalid: validations.filter(([key, v]) => !v).map(([key, v]) => key)
    }
  }
}



/** Returns true if all the arguments are valid strings */
export const allValidString = allValid(validString(1));

/** Checks if all the keys passed in 2nd Argument exists in the Target Object. */
export const validateObjectByKeys = (target = {}, keys = ['name']) => {
  if (!target) {
    return {
      valid: false,
      error: 'undefined',
      errorString: `Object Undefined`,
    }
  }

  const nonExistentKeys = keys.filter(e => !target[e]);
  if (nonExistentKeys.length > 0) {
    return {
      valid: false,
      error: 'nonExistentKey',
      errorString: `Non Existent Keys: ${nonExistentKeys}`,
    }
  }

  return {
    valid: true,
  }
}
/** Checks if the Target Object has the same structure as the Source Object */
export const validateObjectStructure = (target = {}, source = {}) => {
  return validateObjectByKeys(target, Object.keys(source));
}

/** Validate single/multiple emails separated by comma and/or space */
export const isValidEmail = (emails) => {
  const emailValPatern = /^([\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})((,|, ){1}[\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})*$/g;
  return emailValPatern.test(emails);
}


// const section  = 'location';
// const action   = 'add_location_comment';
// const comment  = '2';
// const table_id = '130668';
// const status   = 'public';


// console.log(allValidString({
//   section,
//   action,
//   comment,
//   table_id,
//   status,
// }))

